module.exports = __webpack_public_path__ + "img/bee-welcome-right.c9c99fc9.svg";